import HeaderBodyBox from './HeaderBodyBox';

export default HeaderBodyBox;
